module.exports = __webpack_public_path__ + "static/media/7-7.6b0f9445.mp3";